import ReactGA from 'react-ga4';
import ReactUA from 'react-ga';

/*
* Sends a simple page view event to Google Analytics.
*
* This conditionally uses the old Universal Analytics or the new Google Analytics 4.
*
* @param {string} googleAnalyticsId - The Google Analytics ID to send the event to.
 */
export const googleAnalyticsPageview = (googleAnalyticsId: string) => {
  if (googleAnalyticsId.startsWith('UA')) {
    ReactUA.initialize(googleAnalyticsId);
    ReactUA.pageview(window.location.pathname + window.location.search);
  } else {
    ReactGA.initialize(googleAnalyticsId);
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
      title: window.document.title,
    });
  }
};
